// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ax0-","index":"styles_index__3IQG3"};